import { createRegistry } from '../createRegistry';
export const registry = createRegistry({
    host: 'siteAssets',
});
export default registry;
export * from '../types';
//# sourceMappingURL=siteAssets.js.map